<template>
  <v-app>
    <appbar-view></appbar-view>
    <v-container>
    <v-card class="pa-5">
      <v-list v-if="suggestions.length">
        <v-list-item
          v-for="(place, index) in suggestions"
          :key="index"
          @click="selectPlace(place)"
        >
          {{ place.description }}
        </v-list-item>
      </v-list>

      <GMapMap
        :center="userLocation || center"
        :zoom="15"
        style="width: 100%; height: 500px; border-radius: 10px"
        map-type-id="hybrid"
        @click="setMarker"
      >
        <!-- 📍 Marcador de la empresa -->
        <GMapMarker
          :position="companyLocation"
          :clickable="true"
          :draggable="false"
          @click="toggleInfoWindow"
        />

        <!-- ℹ️ Ventana con información de la empresa -->
        <GMapInfoWindow
          :options="{ content: infoContent }"
          :position="companyLocation"
          :opened="infoWindowOpened"
          @closeclick="infoWindowOpened = false"
        />

        <!-- 📌 Marcador de la ubicación del usuario -->
        <GMapMarker v-if="userLocation" :position="userLocation" icon="http://maps.google.com/mapfiles/ms/icons/blue-dot.png" />
      </GMapMap>

      <!-- 🔘 Botón fijo de "Cómo llegar" -->
      <v-btn
        block
        color="primary"
        class="mt-4"
        @click="openGoogleMaps"
      >
        📍 Cómo llegar
      </v-btn>

    </v-card>
  </v-container>

  </v-app>
 
</template>

<script>
import appbarView from './appbar/appbarView.vue';
/* global google */
export default {
  components: { appbarView },
  data() {
    return {
      center: { lat: 16.77974676915859, lng: -93.1726412483333 },
      companyLocation: { lat: 16.77974676915859, lng: -93.1726412483333 },
      userLocation: null,
      infoWindowOpened: false,
      infoContent: "",
      address: "",
      suggestions: [],
      autocompleteService: null,
      placesService: null,
    };
  },
  mounted() {
    if (window.google) {
      this.autocompleteService = new google.maps.places.AutocompleteService();
      this.placesService = new google.maps.places.PlacesService(
        document.createElement("div")
      );
    } else {
     // console.log("Error: Google Maps no está cargado");
    }

    // 📍 Obtener la ubicación del usuario
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
        },
        (error) => {
          console.error("Error al obtener ubicación:", error);
        }
      );
    }
  },
  methods: {
    openGoogleMaps() {
      // 🔗 Abre solo la ubicación de Peñafiel en Google Maps
      window.open(
        "https://www.google.com/maps?q=16.77974676915859,-93.1726412483333",
        "_blank"
      );
    },
    toggleInfoWindow() {
      this.infoWindowOpened = !this.infoWindowOpened;
    },
  },
};
</script>
